import { type IAdvancedRichText } from '@framework/engine/inputs/rich-text-advanced/IAdvancedRichText.ts';
import { RichTextAdvancedRender } from '@framework/engine/inputs/rich-text-advanced/render/RichTextAdvancedRender.tsx';
import { type IWidgetParsedProps } from '@framework/engine/schema/widgets/repository/inputs/common/util/getWidgetProps.ts';
import { ConfigFormItem } from '@framework/engine/ui/form/ConfigFormItem.tsx';
import { DraggerInput } from '@framework/form/inputs/upload/DraggerInput.tsx';
import { UploadInput } from '@framework/form/inputs/upload/UploadInput.tsx';
import { type default as React } from 'react';
import { type IUploadWidget } from '../IUploadWidget.ts';

export interface IUploadWidgetPreviewInputProps {
  options: IWidgetParsedProps;
  isButton: boolean;
  title: React.JSX.Element | undefined;
  widget: IUploadWidget;
  helpText?: IAdvancedRichText;
  label?: IAdvancedRichText;
}

/**
 * Componente di preview per il widget di tipo upload
 */
export function UploadWidgetPreviewInput(
  props: IUploadWidgetPreviewInputProps,
) {
  const { options, isButton, title, helpText, label } = props;

  return (
    <ConfigFormItem
      name="upload"
      label={<RichTextAdvancedRender text={label} />}
      help={isButton && <RichTextAdvancedRender text={helpText} />}
      layout={{ hideVisualLabel: options.hideLabel }}
      readonly={options.readonly}
      widget={props.widget}
    >
      {isButton ? (
        <UploadInput name="upload" title={title} multiLineButton />
      ) : (
        <DraggerInput
          name="upload"
          title={title}
          info={
            options.helpText ? (
              <RichTextAdvancedRender text={options.helpText} />
            ) : (
              <div />
            )
          }
        />
      )}
    </ConfigFormItem>
  );
}
